import { axiosNT } from '../../../services/axios';

import { ContentTypeData } from "../types/ContentTypeData";


// commented as service is not responding
// remove above code and uncomment below code to make it dynamic
const list = () => axiosNT
  .get("contentType/getContentType")
  .then((res: any) => {
    let ct: ContentTypeData[] = res.responseObject
    return Promise.resolve(ct);
  });

export default {
  list,
};